// extracted by mini-css-extract-plugin
export default {"title":"InfiniteAuctionList_title__J89EP","card":"InfiniteAuctionList_card__V0WJl"};